import styled from "styled-components";
import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ArrowLeftCircle } from "react-bootstrap-icons";

// Modern theme colors
const colors = {
  bg: "#f4f5f7",
  text: "#2e3135ff",
  textLight: "#6a6d74ff",
  hoverBg: "#e8eaef",
  activeBg: "#dfe3eb",
  activeText: "#060709ff",
};

export const NavWrapper = styled(Nav)`
  padding: 12px 0;
  width: 100%;
  display: block;
  NavWrapper h4:first-of-type {
  margin-top: 4px !important;
}
`;

export const SectionTitle = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  color: ${colors.textLight};
  margin: 18px 12px 6px 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const NavItem = styled(Nav.Item)`
  width: 100%;
`;

export const NavLink = styled(Link)`
  display: block;
  color: ${({ $active }) => ($active ? colors.activeText : colors.textLight)};
  background: ${({ $active }) => ($active ? colors.activeBg : "transparent")};
  padding: 10px 14px;
  border-radius: 6px;
  margin: 2px 10px;
  text-decoration: none;
  font-size: 0.95rem;
  transition: 0.2s ease-in-out;

  &:hover {
    background: ${colors.hoverBg};
    color: ${colors.activeText};
  }

  &:active {
    transform: scale(0.98);
  }
`;
export const Sidebar = styled.div`
  position: relative;
  padding: 0 15px;
  background-color: #f4f5f7;
  color: rgb(66, 82, 110);
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #e2e8f0;
  padding-bottom : 100px;

  /* For Chrome, Edge, Safari */
  &::-webkit-scrollbar {
    width: 4px;       /* very thin */
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #c5cbd3;   /* light gray */
    border-radius: 10px;
  }

  /* Firefox */
  scrollbar-width: thin;     /* makes scrollbar thin */
  scrollbar-color: #c5cbd3 transparent;
`;


export const Navigationbar = styled(Navbar)`
  padding: 10px;
  display: block;
`;

export const NavbarToggle = styled(Navbar.Toggle)`
  margin-right: 10px;
`;

export const LeftArrowCircle = styled(ArrowLeftCircle)`
  position: absolute;
  top: 20px;
  right: -9px;
  width: 25px;
  height: 25px;
  cursor: pointer;
  &:hover {
    color: #0d6efd;
  }
`;

export const ParentNavLink = styled.div`
  display: block;
  color: ${({ $active }) =>
    $active ? colors.activeText : colors.textLight};
  background: ${({ $active }) =>
    $active ? colors.activeBg : "transparent"};
  padding: 10px 14px;
  border-radius: 6px;
  margin: 2px 10px;
  font-size: 0.95rem;
  cursor: pointer;
  transition: 0.2s ease-in-out;

  &:hover {
    background: ${colors.hoverBg};
    color: ${colors.activeText};
  }
`;

export const SubMenu = styled.div`
  margin-left: 10px;
`;
